module.exports = __webpack_public_path__ + "static/image6-c5912d0bd7673c0f91046cc4f1d53c88.png";